import { Component, OnInit, ElementRef, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import Swal from 'sweetalert2';

import { ClientService } from '@teem/services/client.service';
import { InvoiceService } from '@teem/services/invoice.service';
import { LoaderService } from '@teem/services/loader.service';
import { messages as i18n } from '@teem/constants/messages';
import { client as ClientApi } from '@teem/constants/api';
import { PAYMENT_TYPES } from '@teem/constants/invoice';
import { parseDate } from '@teem/helpers/functions';

declare var $;

@Component({
  selector: 'refund-payment-modal',
  templateUrl: './refund-payment-modal.component.html',
  styleUrls: ['./refund-payment-modal.component.scss']
})
export class RefundPaymentModalComponent implements OnInit {

  paymentForm: FormGroup;
  paymentTypes: Array<object> = PAYMENT_TYPES;
  submitted: boolean = false;
  @Input('userInfo') userInfo: any;
  @Input('invoice') invoice: any;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private el: ElementRef,
    private clientService: ClientService,
    private invoiceService: InvoiceService,
    private loaderService: LoaderService,

  ) {
  }

  ngOnInit(): void {
    this.paymentForm = this.fb.group({
      client_id: [null, [Validators.required]],
      amount: [null, [Validators.required, Validators.max(0)]],
      payment_type: [null],
      other_note: [null, [Validators.required]],
      date: [moment().format('DD/MM/YYYY'), Validators.required]
    });

    // console.log(this.invoice);
    if (this.invoice && this.invoice.client_uuid) {
      this.paymentForm.get('amount').setValue(this.invoice?.due_amount);
      this.paymentForm.get('client_id').setValue(this.invoice?.client_name);
    }
    setTimeout(() => {
      $('select[nice-select]').niceSelect('update');
    }, 100);
  }


  checkOptionIsAvailable(option) {
    if (option == 'credit-card') {
      return this.userInfo?.halala_mobile ? true : false
    }
    if (option == 'cash') {
      return this.userInfo?.accept_cash_payment ? true : false;
    }
    return true;
  }

  submit() {
    this.submitted = true;
    if (this.paymentForm.valid) {

      let fd = this.paymentForm.value;
      fd.date = parseDate(fd.date);
      fd.invoice_number = this.invoice.invoice_number;
      fd.invoice_id = this.invoice.id
      fd.due_amount = this.invoice?.due_amount;
      fd.client_id = this.invoice?.client_id;

      this.loaderService.startLoading();

      this.invoiceService.refundPayment(fd).subscribe(data => {
        this.loaderService.stopLoading();

        this.activeModal.close(data);
        location.reload();
      }, err => {
        this.loaderService.stopLoading();

        if (err.status == 422) {
          if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
            let validationErrors = err.error.errors;

            Object.keys(validationErrors).forEach((prop) => {
              this.paymentForm.get(prop)?.setErrors({
                serverError: validationErrors[prop]
              })
            })
          }
        }

        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      })
    }
  }

  isNoteFieldEnabled() {
		if (this.paymentForm.value.payment_type === 'other') {
			this.paymentForm.get("other_note").enable();
		} else {
			this.paymentForm.get("other_note").disable();
		}
	}

}
